const localStorageAccess = {
  saveRowsPerPage(identifier: string, value: string | number) {
    localStorage.setItem(`${identifier}RowsPerPage`, value.toString())
  },
  getRowsPerPage(identifier: string): string | null {
    return localStorage.getItem(`${identifier}RowsPerPage`)
  },
}

export default localStorageAccess